/**
 * Recevabilité des dossiers (cahier §10, TODO phase 12, ADR-029).
 * Partagé entre l'API (règles) et les portails (libellés, badges).
 *
 * - Les CONTRÔLES AUTOMATIQUES (« système ») éclairent l'agent ; ils ne décident pas.
 * - Les DÉCISIONS HUMAINES ont un auteur et une date : un agent propose
 *   (`candidature.decide`), une AUTRE personne valide (`candidature.validate`).
 */
/* ------------------------------------------------------------------ */
/* Décisions                                                           */
/* ------------------------------------------------------------------ */
export const DECISION_KINDS = {
    admissible: 'Recevable',
    not_admissible: 'Non recevable',
};
export const DECISION_STATUSES = {
    proposed: 'En attente de validation',
    validated: 'Validée',
    returned: 'Renvoyée pour réexamen',
};
/** Motif obligatoire (non recevable, renvoi, complément) : longueur minimale. */
export const DECISION_REASON_MIN = 10;
/** États dans lesquels une proposition « non recevable » peut être validée. */
export const NOT_ADMISSIBLE_FROM = [
    'submitted',
    'under_review',
    'to_complete',
];
/** États où le dossier est en cours de traitement administratif. */
export const REVIEW_ACTIVE_STATES = [
    'submitted',
    'under_review',
    'to_complete',
];
/* ------------------------------------------------------------------ */
/* Compléments                                                         */
/* ------------------------------------------------------------------ */
export const COMPLEMENT_STATUSES = {
    open: 'En attente du candidat',
    answered: 'Complément fourni',
    expired: 'Délai dépassé',
    closed: 'Clos par la décision',
};
export const COMPLEMENT_DEFAULT_DAYS = 7;
export const COMPLEMENT_MAX_DAYS = 60;
/* ------------------------------------------------------------------ */
/* Contrôles automatiques                                              */
/* ------------------------------------------------------------------ */
export const SYSTEM_CHECKS = {
    payment: 'Paiement des frais d’inscription',
    antivirus: 'Analyse antivirus des pièces',
    identity_scan: 'Copie de la pièce d’identité',
    eligibility: 'Conditions d’âge',
    duplicates: 'Doublons potentiels',
};
//# sourceMappingURL=admissibility.js.map